import Modal from "@/common/components/Modal";
import SmallBadge from "@/common/components/SmallBadge";
import useModalMessagesSimple from "@/common/hooks/useModalMessagesSimple";
import { useQueryClient } from "@tanstack/react-query";
import { BellOffIcon } from "lucide-react";
import { useState } from "react";
import { useMaintenanceEstablishmentChoiceAuctionEntryUnfollow } from "../../../hooks/useMaintenanceEstablishmentChoiceAuctionEntryUnfollow";

interface UnfollowAuctionProps {
  auctionEntryId: string | undefined;
}

const UnfollowAuction = ({
  auctionEntryId,
}: UnfollowAuctionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const {
    setMessages
  } = useModalMessagesSimple({
    isError: true,
  });

  const {
    mutate: unfollow,
    isPending: followIsPending,
  } = useMaintenanceEstablishmentChoiceAuctionEntryUnfollow({
    auctionEntryId,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceEstablishmentChoiceAuctionEntryUpdatedSummary', auctionEntryId],
        });

        setIsOpen(false);
      },
      onError: (error) => {
        setMessages(error, { errorResponse: true });
      }
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      triggerAsChild
      Trigger={(
        <SmallBadge
          LeftIcon={BellOffIcon}
          text="Parar de acompanhar"
          className="bg-danger hover:bg-[#E03E1AAA] transition-colors cursor-pointer"
        />
      )}
      bodyClassName='max-h-[calc(90vh-72px-48px)] overflow-auto'
      title="Você tem certeza?"
      subtitle="Você não irá mais acompanhar as atualizações desse leilão"
      titleClass="text-2xl"
      subtitleClassName="text-base mt-1"
      useCancellableFooter
      className="rounded-lg overflow-hidden"
      cancelButtonClassName="bg-white-100 rounded-es-lg"
      confirmButtonClassName="bg-primary-blue rounded-ee-lg"
      confirmButtonIsLoading={followIsPending}
      disabled={followIsPending || !auctionEntryId}
      showClose={false}
      onConfirm={() => unfollow()}
    />
  );
}

export default UnfollowAuction;
